
export default class DashboardTabindexjs {
    constructor() {
        this.init();
    }

    init() {
        let currentTabindex = 0;
        let fixIndex = 0;
        let fixIndexMax = 0;
        setTimeout(()=>{
            //Disable tabindex
            $('.header-container a, .header-container input, .dashboard-template-column-side a').attr('tabindex', -1);

            //Custom enabled tabindex
            $('textarea, input, input:hidden, select, select:hidden, a, a:hidden, button, button:hidden, div[name="Payment"] #stripepayment').each(function (i) {
                currentTabindex = parseInt(i + 1)
                let dataTabIndex = $(this).attr('dataTabindex')
                if(typeof(dataTabIndex) !== 'undefined' && dataTabIndex !== ''){
                    if(fixIndex === 0){
                        fixIndex = currentTabindex
                    }
                    fixIndexMax = fixIndex + parseInt(dataTabIndex)
                    $(this).attr('tabindex', fixIndexMax)
                }else{
                    if(fixIndexMax > 0 && fixIndex > 0){
                        currentTabindex = fixIndexMax
                        fixIndexMax = fixIndex = 0
                    }
                    $(this).attr('tabindex', currentTabindex)
                }
            })
        }, 1000)
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/dashboardTabindex.js